import './review-sections.css'

interface ExecutiveSummaryData {
  cycle_grade: string
  grade_rationale: string
  key_wins: string[]
  key_misses: string[]
  one_line_recommendation: string
  cycle_trend: string
}

interface Props {
  data: ExecutiveSummaryData
}

function getGradeClass(grade: string): string {
  const letter = grade.charAt(0).toUpperCase()
  if (letter === 'A') return 'grade-a'
  if (letter === 'B') return 'grade-b'
  if (letter === 'C') return 'grade-c'
  return 'grade-d'
}

function getTrendDisplay(trend: string): { label: string; icon: string; className: string } {
  switch (trend) {
    case 'improving': return { label: 'Improving', icon: '\u2191', className: 'trend-improving' }
    case 'declining': return { label: 'Declining', icon: '\u2193', className: 'trend-declining' }
    case 'stable': return { label: 'Stable', icon: '\u2192', className: 'trend-stable' }
    default: return { label: 'First Review', icon: '\u2605', className: '' }
  }
}

export default function ExecutiveSummary({ data }: Props) {
  const trend = getTrendDisplay(data.cycle_trend)

  return (
    <div className="executive-summary">
      <div className="exec-header">
        <h3>Executive Summary</h3>
        <div className={`grade-badge ${getGradeClass(data.cycle_grade)}`}>
          {data.cycle_grade}
        </div>
      </div>

      <p className="grade-rationale">{data.grade_rationale}</p>

      <div className="exec-columns">
        <div className="exec-wins">
          <h4>Key Wins</h4>
          <ul>
            {(data.key_wins || []).map((win, i) => (
              <li key={i}>{win}</li>
            ))}
          </ul>
        </div>
        <div className="exec-misses">
          <h4>Key Misses</h4>
          <ul>
            {(data.key_misses || []).map((miss, i) => (
              <li key={i}>{miss}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="exec-recommendation">{data.one_line_recommendation}</div>

      <span className={`exec-trend ${trend.className}`}>
        {trend.icon} {trend.label}
      </span>
    </div>
  )
}
